/// <amd-module name="VSS/Features/Search/SearchHeader" />
export * from "./SearchHeader/SearchHeader";
